const GapChaseLoadingStatus = {
    Error: 'Error',
    NotStarted: 'Not Started',
    InProgress: 'In Progress',
    Retrying: 'Retrying',
    Complete: 'Complete'
}
Object.freeze(GapChaseLoadingStatus);

export default GapChaseLoadingStatus;